<div class="objectivesAssignBox my-2">
    <div class="search-box live-search px-3 mt-3">
        <input type="search" class="form-control" cvLocalizedPlaceholder langSection="Assign_Tool" langKey="Search" [(ngModel)]="search" (ngModelChangeDebounced)="updateSearchFilter($event)"/>
        <span class="clear-input mr-3" [hidden]="!(search.length > 0)" (click)="updateSearchFilter('')"></span>
    </div>

    <div class="boxHeader pl-3 pt-2" cvLocalizedText langSection="Assign_Tool" langKey="Assigned_To">Assigned to:</div>
    
    <div class="assignToContainer overflow-auto my-2 mx-0" *ngIf="(searchFilter.length == 0 || (lst | assignBox: searchFilter).length)" [ngStyle]="{'height': setHeight()}" style="border-bottom: 1px solid #E2E2E2;">
        <!-- EMPLOYEE GROUPS -->
        <div class="typeHeader lato-bold font-size-16 d-flex align-items-center mt-0">
            <div><span cvLocalizedText langSection="Assign_Tool" langKey="Employee_Groups">Employee Group(s)</span></div>
            <div class="ml-auto"><input type="checkbox" *ngIf="empSelected()" [(ngModel)]="selectAllEmp" (ngModelChange)="selection('emp')"/></div>
        </div>
        <div class="objectiveHeaderItem" *ngIf="showAll && !empSelected()" cvLocalizedText langSection="Assign_Tool" langKey="No_Groups">No Groups</div>
        <div class="warningItem" *ngIf="!showAll && !empSelected()" cvLocalizedText langSection="Assign_Tool" langKey="Select_One">*Select at least one group</div>
        <div *ngFor="let obj of lst | assignBox: searchFilter; let i = index">
            <div *ngIf="obj.BaseGroupType == 0" class="d-flex flex-row align-items-center mx-3">
                <div class="objectiveItem txtOverflow">- {{obj.GroupName}}</div>
                <select class="selectItem" [ngModel]="obj.applyAt" *ngIf="showAll == false && obj.GroupLevel > 1">
                    <option *ngFor="let item of empgrouptypes" [hidden]="!(item.GroupLevel <= obj.GroupLevel)" value="{{item.GroupLevel}}">{{item.GroupTypeName}}</option>
                </select>
                <div class="ml-auto">
                    <input id="emp{{obj.GroupID}}" type="checkbox" [ngModel]="empSelection[i]" (change)="checkSelection('emp', obj, i)"/>
                </div>
            </div>
        </div>

        <!-- CALL GROUPS -->
        <div *ngIf="type!=='awardsAddEdit'">
            <div class="typeHeader lato-bold font-size-16 mt-2 d-flex align-items-center">
                <div><span cvLocalizedText langSection="Assign_Tool" langKey="Call_Groups">Call Group(s)</span></div>
                <div class="ml-auto"><input type="checkbox" *ngIf="recSelected()" [(ngModel)]="selectAllRec" (ngModelChange)="selection('rec')"/></div>
            </div>
            <div class="objectiveHeaderItem" *ngIf="showAll && !recSelected()" cvLocalizedText langSection="Assign_Tool" langKey="No_Groups">No Groups</div>
            <div class="warningItem" *ngIf="!showAll && !recSelected()" cvLocalizedText langSection="Assign_Tool" langKey="Select_One">*Select at least one group</div>
            <div *ngFor="let obj of lst | assignBox: searchFilter; let i = index">
                <div *ngIf="obj.BaseGroupType == 1" class="d-flex align-items-center mx-3">
                    <div class="objectiveItem txtOverflow">- {{obj.GroupName}}</div>
                    <select class="selectItem" [ngModel]="obj.applyAt" *ngIf="!showAll && obj.GroupLevel > 1">
                        <option *ngFor="let item of recgrouptypes" [hidden]="!(item.GroupLevel <= obj.GroupLevel)" value="{{item.GroupLevel}}">{{item.GroupTypeName}}</option>
                    </select>
                    <div class="ml-auto"><input id="rec{{obj.GroupID}}" type="checkbox" [ngModel]="recSelection[(i - empSelection.length)]" (change)="checkSelection('rec', obj, i)"/></div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="searchFilter.length>0 && !(lst | assignBox: searchFilter).length" class="d-flex justify-content-center align-items-center" style="height: 71%">
        <h7 class="font-weight-bold text-center px-4" cvLocalizedText langSection="Assign_Tool" langKey="No_Data">Sorry, no data was found.</h7>
    </div>

    <div class="d-flex justify-content-end" *ngIf="lst.length > 0">
        <button type="button" class="btn btn-secondary btn-sm mr-4" (click)="deleteGroups()" [disabled]="!enableDelete()" cvLocalizedText langSection="Common" langKey="Delete">Delete</button>
    </div>
</div>
